import "./ScaffoldingInWoking.module.css";
import Header from "@/reusable_sections/Header";
import HeroWoking from "./sections/HeroWoking";
import WokingIntro from "./sections/WokingIntro";
import WokingServices from "./sections/WokingServices";
import WokingSafety from "./sections/WokingSafety";
import WokingFaq from "./sections/WokingFaq";
import QuoteCta from "./sections/QuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInWokingPage() {
  return <div>
      <Header />
      <HeroWoking />
      <WokingIntro />
      <WokingServices />
      <WokingSafety />
      <WokingFaq />
      <QuoteCta />
      <Footer />
    </div>;
}